module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("faq_tags", [["div",{"class":"tags-wrapper"},[["div",{"class":"fqb-title clearfix"},[["span",{"class":"","data-fox-alias":"1","data-fox-context":"faq_tags"},[["textNode",{"text":"Categories"}]]]]],["div",{"class":"fqb-content"},[["ul",{"class":"fqb-tags-list"}]]]]]]);
fox.registerTemplate("faq_tags_item", [["li",{},[["a",{"href":"/faq/tag=&&0&&"},[["span",{},[],[["alias","__text",true]]]],[["alias","href"]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/templates/sitepage/faq/tags.tpl
// module id = 494
// module chunks = 2